<template>
<div class="error main__error">
    <div class="inner">
        <h2 class="error__tit">{{ msg }}</h2>
        <Btn v-if="!errorToHome" :href="surveyTop" class="error__btn">アンケートに戻る</Btn>
        <Btn v-else :href="home" class="error__btn">HOMEへ</Btn>
    </div>
</div>
</template>

<script>
import Btn from '../components/Btn.vue';

export default {
    components: {
		Btn,
	},

    props: ['msg', 'errorToHome', 'isYappli'],

    computed: {
        // アンケートトップのURL
        surveyTop() {
            const url = window.location.pathname; //URLを取得
		    const urlArray = url.split('/'); //URLを配列に格納
            const href = `/${urlArray.slice(1, 3).join('/')}/`; //アンケートTOPのURLを抽出
            return href;
        },

        // HOMEのURL
        home() {
            if (this.isYappli) return 'native:/tab/scrollmenu/f16bae57';
            return 'https://www.yamaokaya.com/';
        }
    },
}
</script>